import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const applicationavailibility = require("../../../assets/icons-pack/5.4 Load Balancer/ic_01_applicationavailibility.svg");
const selfshared = require("../../../assets/icons-pack/5.4 Load Balancer/ic_02_selfshared.svg");
const dedicatednetwork = require("../../../assets/icons-pack/5.4 Load Balancer/ic_03_dedicatednetwork.svg");

const LoadBalancer = () => {
    const heading = `LOAD BALANCER (LBAAS)`;
    const details = `Automatically distributes incoming traffic across multiple servers to balance the workload, increasing the service capabilities and fault tolerance of your applications.`;

    const overview = [
        `Real-world application performance can be unpredictable. To ensure maximum up-time and reliability, the DETASAD platform offers a portfolio of cloud load balancers available on DETASAD’s Market Place. Less complex applications can deploy standard load balancers, while more involved apps can use Advance load balancers that support advanced layer 4 and layer 7 (L4 and L7) rules. Web Application Firewall & SSL offloading is also available, the Customer can use for internal or external load balancing purpose.`
    ];

    const advantages = [
        [
            `Enhanced Performance`,
            `DETASAD’s Load Balancer is able to handle millions of concurrent connections.`,
            applicationavailibility
        ],
        [
            `Highly Available`,
            `Our Load Balancer can route traffic to healthy servers, ensuring that access to your resources remain uninterrupted.`,
            selfshared
        ],
        [
            `Easy to Configure`,
            `A variety of protocols and algorithms enable you to configure traffic routing policies to suit your needs while keeping deployments simple.`,
            dedicatednetwork
        ],
        [
            `Intelligent`,
            `Deeply integrated with DETASAD’s Auto Scaling, the Load Balancer is intelligent to detect and forward the incoming traffic to scalable healthy servers.`,
            selfshared // temp
        ]
    ];
    const functions = [
        [
            `Application Availability`,
            [`Includes L4 load balancing and L7 content switching, as well as database load balancing; supports IPv6.`]
        ],
        [
            `Self-Service Shared Load Balancers`,
            [
                `Create cloud load balancer configurations that use either “least connection” or “round robin” routing policies, and either standard or sticky persistence.`
            ]
        ],
        [
            `Dedicated Network Load Balancers`,
            [
                `Create and configure pools of virtual servers using our intuitive Control Portal. Have a question? Our team of network engineers is standing by 24x7 to help you design and deploy the right load balancer for your app.`
            ]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-network"/>
            <SubNav overview={overview} advantages={advantages} functions={functions}/>
            <Footer />
        </div>
    );
};

export default LoadBalancer;
